import { IndexableType } from 'dexie'
import { GlobalIndexDbService, ILocation, Locations } from './globalIndexDb.service'

export class LocationService {
  private db: GlobalIndexDbService
  private tableName: string

  constructor() {
    this.db = new GlobalIndexDbService()
    this.tableName = this.db.locations.name
  }

  async addAllLocationsData(locationsData: Locations) {
    return await this.db.addAll(locationsData, this.tableName)
  }

  async createOrUpdateAllLocationsData(locationsData: Locations): Promise<IndexableType> {
    return await this.db.updateAll(locationsData, this.tableName)
  }

  async deleteAllLocationsData(primaryKeys: string[]): Promise<void> {
    return await this.db.deleteAll(primaryKeys, this.tableName)
  }

  async getLocation(id: string): Promise<ILocation | undefined | null> {
    return await this.db.get(id, this.tableName)
  }

  async getLocationByCityState(city: string, state: string) {
    const zips = await this.db.getWhereAttributeEquals('[state+city]', [state, city], this.tableName)
    return zips
  }

  async getLocationPrimaryKeysPerState(state: string) {
    const zips = await this.db.getPrimaryKeysByIndex('state', state, this.tableName)
    return zips
  }
}
